import { render, staticRenderFns } from "./NewMsisdnDialog.vue?vue&type=template&id=b4727ff6&"
import script from "./NewMsisdnDialog.vue?vue&type=script&lang=js&"
export * from "./NewMsisdnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports